{
  "version": 1,
  "asset_id": "6dcd9a19-4ea4-4f41-afa2-ef354b93de9c",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/6dcd9a19-4ea4-4f41-afa2-ef354b93de9c/raindrop-sledge-hammer.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/6dcd9a19-4ea4-4f41-afa2-ef354b93de9c/raindrop-sledge-hammer.mp4",
  "original_filename": "raindrop-sledge-hammer.mp4",
  "size": 8236918,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:18:08Z"
}
